import { render, staticRenderFns } from "./MbInitiateProcess.vue?vue&type=template&id=6289fc84&scoped=true"
import script from "./MbInitiateProcess.vue?vue&type=script&lang=js"
export * from "./MbInitiateProcess.vue?vue&type=script&lang=js"
import style0 from "./MbInitiateProcess.vue?vue&type=style&index=0&id=6289fc84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6289fc84",
  null
  
)

export default component.exports